<app-navbar></app-navbar>

<section class="premium-3d-message-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <ng-container *ngIf="cheif_patron_data !== null">
                    <div class="ultimate-3d-card message-card p-5">
                        <div class="row align-items-start">
                            <div class="col-md-5 text-center mb-4 mb-md-0 position-relative">
                                <div class="message-image-wrapper mx-auto">
                                    <img alt="Profile Image" class="img-fluid message-img" [src]="cheif_patron_data.GBImagePath" appFallbackImage>
                                </div>
                                <div class="floating-glass-badge designation-badge mt-4">
                                    {{cheif_patron_data.GBDesignationName || 'সভাপতির বাণী'}}
                                </div>
                            </div>
                            
                            <div class="col-md-7 ps-md-4">
                                <h1 class="ultimate-3d-title mb-2" style="font-size: 36px;">{{cheif_patron_data.GBName}}</h1>
                                <p class="text-success fw-bold mb-4" style="font-size: 18px; letter-spacing: 0.5px; text-transform: uppercase;">
                                    {{cheif_patron_data.GBDesignationName || 'Chairman'}}
                                </p>
                                
                                <div class="premium-header-divider mb-4"></div>
                                
                                <article class="ultimate-text-content message-text">
                                    <div [innerHTML]="cheif_patron_data.DetailsBn || cheif_patron_data.DetailsEn"></div>
                                </article>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>